/**
 * Indian digit grouping (`en-IN`) for non-currency numbers.
 * Currency must use {@link formatMoney} / `<Money>` only.
 */

/* eslint-disable no-restricted-syntax -- not currency; plain numeric grouping per project i18n rules */
const intFormatter = new Intl.NumberFormat('en-IN', {
  maximumFractionDigits: 0,
});

const decimalFormatter = new Intl.NumberFormat('en-IN', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 6,
});
/* eslint-enable no-restricted-syntax */

export function formatNumber(value: number, style: 'integer' | 'decimal' = 'integer'): string {
  if (!Number.isFinite(value)) return '—';
  return style === 'integer' ? intFormatter.format(value) : decimalFormatter.format(value);
}
